import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import PropTypes from "prop-types";
import * as actions from "../actions";
import downloadViewStateToProps from "../selectors";
import EditFormLayout from "./EditFormLayout";

class EditFormView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSampleId: "",
      workingSampleId: ""
    };
  }

  async componentDidMount() {
    document.title = "Edit Form JSON";
  }

  handleSearchChange(event) {
    this.setState({ currentSampleId: event.target.value });
  }

  handleSearchClick() {
    this.setState(prevState => ({
      workingSampleId: prevState.currentSampleId
    }));
    this.props.actions.fetchFormSearchResults(this.state.currentSampleId);
    this.props.actions.fetchFormHistory(this.state.currentSampleId);
    this.props.actions.acknowledgeFormContentChanged();
  }

  handleFormSaveClick(newFormJson) {
    this.props.actions.submitFormChanges(
      this.state.workingSampleId,
      newFormJson
    );
    this.props.actions.acknowledgeFormContentChanged();
  }

  render() {
    return (
      <EditFormLayout
        {...this.props}
        /* eslint-disable-next-line react/jsx-no-bind */
        onSearchClick={this.handleSearchClick.bind(this)}
        /* eslint-disable-next-line react/jsx-no-bind */
        onSearchChange={this.handleSearchChange.bind(this)}
        /* eslint-disable-next-line react/jsx-no-bind */
        onFormEditSaveClick={this.handleFormSaveClick.bind(this)}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

EditFormView.propTypes = {
  actions: PropTypes.shape({
    fetchFormSearchResults: PropTypes.func.isRequired,
    fetchFormHistory: PropTypes.func.isRequired,
    submitFormChanges: PropTypes.func.isRequired,
    acknowledgeFormContentChanged: PropTypes.func.isRequired
  }).isRequired,
  existingFormText: PropTypes.string
};

EditFormView.defaultProps = {
  existingFormText: "{}"
};

export default withRouter(
  connect(downloadViewStateToProps, mapDispatchToProps)(EditFormView)
);
